import React, { useEffect, useState, useRef, useCallback } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useSwipeable } from "react-swipeable";

import Deepak from "../assets/Mentors/Deepak.webp";
import Balram from "../assets/Mentors/Balram.webp";
import Giri from "../assets/Mentors/Giri.webp";
import Nalluri from "../assets/Mentors/Nalluri.webp";
import Nanaji from "../assets/Mentors/Nanaji.webp";
import Noel from "../assets/Mentors/NoelJeevanNazareth.webp";
import Piyush from "../assets/Mentors/Piyush.webp";
import Rohit from "../assets/Mentors/Rohit.webp";
// import SujanMon from "../assets/Mentors/SujanMon.webp";
// import SuryanMon from "../assets/Mentors/SuryanMon.webp";
import SwamyBogaram from "../assets/Mentors/Swamy_Bogaram.webp";
import Akram from "../assets/Mentors/Akram.webp";

const mentors = [
  {
    name: "Mohammad Akram Khan",
    title: "Graphic, Web & 3D Animation Trainer",
    image: Akram,
    bio: "25 Years of teaching and production experience. Guest Lecturer in one of the Indias's prestigious institution 'National Institute Of Fashion Technology' (NIFT) Hyd. Trained 2,000 + students. Worked in many National and International projects.",
  },
  {
    name: "Swamy Bogaram",
    title: "VFX Artist",
    image: SwamyBogaram,
    bio: "Worked in Movies like Harry Potter, X Men, Godzilla, Avengers, Men In Black, Brahmastra, Lucifer, Fast X, Vishwambhara, Thug Life... Many More..",
  },
  {
    name: "Deepak Rai",
    title: "Senior VFX Artist",
    image: Deepak,
    bio: "10-year work experience to multinational VFX company like Deluxe, Method, MPC, Legend and Outpost VFX.\nInternational movie contribution in The Lord of the Rings: The Rings of Power, Westworld - Adapt or Die, Thor: Love and Thunder, Jurassic World, Sonic the Hedgehog 2, Sonic the Hedgehog. Indian feature films like Shamshera , RRR and many more.",
  },
  {
    name: "Balram",
    title: "Senior 3D Animator",
    image: Balram,
    bio: "Expert in all kind of Slot Gaming Animations and Particle effects with animations.\nWorked in International movies like Disney Heroes: Battle Mode , CosmoSlots, The SwanPrincess 2",
  },
  {
    name: "Giri",
    title: "SR. VFX Lighting Artist",
    image: Giri,
    bio: "Worked in MPC (Moving Picture Company) Contributed in Aquaman, House of the Dragon, Ant-Man, Kraven the Hunter, Sonic 2, Mufasa: The Lion King",
  },
  {
    name: "Nalluri V P V Prasad",
    title: "Senior VFX Artist and Trainer",
    image: Nalluri,
    bio: "Worked in national and international studios like Fluid fx Dynamics, RVML , Padmanaga telefilms.\nContributed in many prestigious international movies like Lord Of The Rings, Shrek, Batman, Chronicles Of Narnia, And Indian movies like Radha Gopalam, House full, Sathyamevajayathe, Aparichitudu, Lavakusa, Kakhi, Toss etc as a senior Vfx Lead and Supervisor roles.",
  },
  {
    name: "Nanaji",
    title: "3d Animator ",
    image: Nanaji,
    bio: "7+ years of experience in the Animation industry\nCollaborated on various platforms such as TV series, a Web series, Al, synthetic data, AR/VR. And Amongst the main projects are Facebook Meta, Home security synthetic data (Google)Ladybug session 3,4&5, Arctic friends, Puffins, Robinhood, Smash, Chico Bon Bon, etc.,working in Game Loft Canada.",
  },
  {
    name: "Noel Jeevan Nazareth",
    title: "Assistant Professor in Prerana Degree College, Manglore",
    image: Noel,
    bio: "Experienced trainer with a demonstrated history of working in the higher education setup.\nLecturing, Graphic Design, Video Editing, Animation, Digital Marketing. Helped brands & businesses in communicating stories through edited video content.",
  },
  {
    name: "Piyush Bairagi",
    title: "Co-founder of iDREAMZZS STUDIO.",
    image: Piyush,
    bio: "Worked in different international studios as an FX Artist. Contributed in international movies like Tinkerbell, Disney Planes and Saving Santa.",
  },
  {
    name: "Rohit Joshi",
    title: "Lead 3D Animator",
    image: Rohit,
    bio: "10+ Years Experience\nExpertise in various animation styles, like snappy, realistic, character animation, kids specific animation and many more as per creative input.\nMajor projects includes Desperados III, Badla, Uri (The surgical Strike) and many other satirical news videos and promos for Nickelodeon and Cartoon Network. Contributed in Disney and Pixar projects.",
  },
  // {
  //   name: "SujanMon",
  //   title: "Video Editing Specialist",
  //   image: SujanMon,
  //   bio: "Crafts compelling visual stories.",
  // },
  // {
  //   name: "SuryanMon",
  //   title: "Video Editing Specialist",
  //   image: SuryanMon,
  //   bio: "Creative editor with an artistic touch.",
  // },
];

const Mentors = () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const mentorsPerPage = isLargeScreen ? 2 : 1;

  const totalRealSlides = Math.ceil(mentors.length / mentorsPerPage);

  const generateSlides = () => {
    const slides = [];

    for (let i = 0; i < totalRealSlides; i++) {
      slides.push(
        mentors.slice(
          i * mentorsPerPage,
          Math.min((i + 1) * mentorsPerPage, mentors.length)
        )
      );
    }

    const extendedSlides = [slides[slides.length - 1], ...slides, slides[0]];

    return extendedSlides;
  };

  const extendedSlides = generateSlides();
  const totalSlides = extendedSlides.length;

  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const checkScreenSize = () => {
      if (containerRef.current) {
        setIsLargeScreen(window.innerWidth >= 1024);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleTransitionEnd = () => {
    if (currentSlide === totalSlides - 1) {
      // At the cloned first slide (at the end)
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentSlide(1); // Go to the real first slide
      }, 50);
    } else if (currentSlide === 0) {
      // At the cloned last slide (at the beginning)
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentSlide(totalSlides - 2); // Go to the real last slide
      }, 50);
    } else {
      setIsTransitioning(false);
    }
  };

  const goToNext = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => prev + 1);
  }, [isTransitioning]);

  const goToPrev = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => prev - 1);
  }, [isTransitioning]);

  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 5000);

    return () => clearInterval(interval);
  }, [isTransitioning, goToNext, currentSlide]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: goToNext,
    onSwipedRight: goToPrev,
    trackMouse: true,
    preventDefaultTouchmoveEvent: true,
  });

  const displayDotIndex = (index) => {
    if (index === 0) return totalSlides - 3;
    if (index === totalSlides - 1) return 0;
    return index - 1;
  };

  return (
    <section
      id="mentors"
      className="flex flex-col justify-center items-center bg-[#090522] py-8 px-4 md:px-8"
      ref={containerRef}
    >
      <h2 className="text-3xl md:text-4xl font-bold mb-6 md:mb-8 text-center">
        <span className="text-orange-500">FEATURED </span>
        <span className="text-yellow-400">MENTORS</span>
      </h2>

      <div className="w-full max-w-4xl relative">
        {/* Navigation Arrows - visible on all screen sizes */}
        <button
          onClick={goToPrev}
          className="absolute top-1/2 -translate-y-1/2 left-0 md:-left-5 lg:-left-8 bg-gray-800 text-white rounded-full w-8 h-8 md:w-10 md:h-10 flex items-center justify-center hover:bg-gray-600 z-10"
          aria-label="Previous slide"
        >
          <FaArrowLeft />
        </button>
        <button
          onClick={goToNext}
          className="absolute top-1/2 -translate-y-1/2 right-0 md:-right-5 lg:-right-8 bg-gray-800 text-white rounded-full w-8 h-8 md:w-10 md:h-10 flex items-center justify-center hover:bg-gray-600 z-10"
          aria-label="Next slide"
        >
          <FaArrowRight />
        </button>

        {/* Swipeable Slider */}
        <div
          {...swipeHandlers}
          className="relative w-full overflow-hidden rounded-lg"
        >
          <div
            ref={sliderRef}
            className={`flex ${
              isTransitioning
                ? "transition-transform duration-500 ease-in-out"
                : ""
            }`}
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            onTransitionEnd={handleTransitionEnd}
          >
            {extendedSlides.map((slideMentors, slideIndex) => (
              <div
                key={slideIndex}
                className="min-w-full flex flex-col lg:flex-row gap-4 lg:gap-6"
              >
                {slideMentors.map((mentor, mentorIndex) => (
                  <div
                    key={`${slideIndex}-${mentorIndex}`}
                    className={`flex-1 bg-black rounded-lg overflow-hidden flex flex-col ${
                      isLargeScreen ? "w-1/2" : "w-full"
                    }`}
                  >
                    <div className="flex flex-col items-center p-4 md:p-6 select-none flex-grow">
                      {/* Top - Photo */}
                      <div className="relative w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 mb-4 flex-shrink-0">
                        <img
                          src={mentor.image}
                          alt={mentor.name}
                          className="w-full h-full object-contain rounded-lg"
                        />
                      </div>

                      {/* Bottom - Bio & Title */}
                      <div className="text-white text-center flex flex-col flex-grow justify-between">
                        <div className="overflow-y-auto max-h-36 sm:max-h-40 md:max-h-48">
                          <p className="text-xs sm:text-sm mb-4">
                            {mentor.bio}
                          </p>
                        </div>
                        <div className="mt-auto pt-3 md:pt-4">
                          <h3 className="text-xl md:text-2xl font-bold">
                            {mentor.name}
                          </h3>
                          <p className="text-base md:text-xl text-gray-300 mt-1 md:mt-2">
                            {mentor.title}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="h-2 md:h-3 bg-gradient-to-r from-orange-500 to-yellow-300 w-full mt-auto"></div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Dots - now based on actual slides, not clones */}
        <div className="flex justify-center mt-4 md:mt-6 mb-8 space-x-2">
          {Array.from({ length: totalRealSlides }).map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setIsTransitioning(true);
                setCurrentSlide(index + 1); // +1 because the first slide is a clone
              }}
              className={`w-2 h-2 md:w-3 md:h-3 rounded-full ${
                displayDotIndex(currentSlide) === index
                  ? "bg-yellow-400"
                  : "bg-gray-400"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Mentors;
